exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "admin-logs>.row{padding-left:15px;margin-right:0px;margin-top:1rem}admin-logs>.row>.col-md-3{border-right:1px solid #ffffff85}.admin-logs-header{justify-content:space-between !important}.admin-logs-header>div{color:white;opacity:.6}.admin-logs-header>div>i{color:#F94E0C}\n", ""]);

// exports
